const initialState = {
  awardsData: [],
  isLoading: false,
  seekerAnalytics: [],
  seekerSubmitted: [],
};

const seekerAwardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "seekerAwardsData":
      state = { ...state, awardsData: action.payload };
      return state;
    case "seekerAnalyticsAction":
      state = { ...state, seekerAnalytics: action.payload };
      return state;
    case "seekerSubmittedAction":
      state = { ...state, seekerSubmitted: action.payload };
      return state;
      case "seekerAwardsLoader":
        state = { ...state, isLoading: action.payload };
        return state;
    default:
      return state;
  }
};
export default seekerAwardsReducer;
